module.exports = __webpack_public_path__ + "images/category_lp/common/icon-toku_7f95143c8b35134b072c2206b9af7bab.png";